import React from 'react';

const WebAutomation = () => {
  return (
    <div>
      <h2>Selenium Automation</h2>
      <p>
        Welcome to the Selenium Automation section. Here you can explore tools like Selenium WebDriver.
      </p>
    </div>
  );
};

export default WebAutomation;
